/**
 * Query parameters that are allowed to reach Google Analytics.
 *
 * Everything else is stripped from `page_location` before GA sees it. URLs in
 * the ClubEzy web apps carry one-time secrets (Firebase `oobCode` in email
 * action links, invite tokens) and occasionally email addresses, none of
 * which may leave for a third party. An allow-list rather than a block-list
 * so a new sensitive parameter is safe by default.
 *
 * Campaign parameters are kept so arrivals from the marketing site and ads
 * stay attributable.
 */
const ALLOWED_PARAMS = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'gclid',
  'gbraid',
  'wbraid',
]);

/**
 * Origin + path + allow-listed query parameters. The fragment is dropped.
 * Returns the input unchanged if it cannot be parsed, minus anything after
 * `?` or `#`.
 */
export function sanitiseAnalyticsUrl(href: string): string {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return href.split(/[?#]/, 1)[0];
  }
  const kept = new URLSearchParams();
  url.searchParams.forEach((value, key) => {
    if (ALLOWED_PARAMS.has(key.toLowerCase())) kept.append(key, value);
  });
  const query = kept.toString();
  return `${url.origin}${url.pathname}${query ? `?${query}` : ''}`;
}
